import { render, staticRenderFns } from "./PagesTreeView.vue?vue&type=template&id=488e3998&scoped=true"
import script from "./PagesTreeView.vue?vue&type=script&lang=js"
export * from "./PagesTreeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e3998",
  null
  
)

export default component.exports